import React, { Component, textarea } from 'react';
import { reduxForm, Field } from 'redux-form';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { toastr } from 'react-redux-toastr';
import { changeTab } from '../../actions/tab';
import { MESSAGES, TABS } from '../../utils/strings';
import { required, renderField, validate, __, renderTextAreaField, massageUrl } from './utils';
import { bulkAddCustomUrl } from '../../actions/privateUrls';
import { getPlan } from '../../actions/plan';
import PropTypes from 'prop-types';
import './form.scss';
import PDABaseClass from '../abstract';

class PuPForm extends PDABaseClass {
  constructor (props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
    this.state = {
      loadingData: false,
    };
    this.wpData = {
      isLicenseExpired: window.pda_gold_v3_data.is_license_expired,
    };
  }

  render () {
    const { handleSubmit, pristine, submitting, plan } = this.props;
    const isPlanLite = plan.planName === 'lite';
    const form = (
      <div className="pup-form">
        <form className="pda_wrap_form_custom_private_link"
              onSubmit={handleSubmit(this.onSubmit)}>
          <div>
            <p>
              {/*<p>{MESSAGES.FILE_TO_CONFIG} <b>"{post.title}"</b> file</p>*/}
            </p>
          </div>
          <div>
            <p>
              <Field name="is_prevented" id="is_prevented" component="input"
                     type="checkbox"/> <label htmlFor="is_prevented">
	            {__('Is this download URL active?')}
            </label>
            </p>
          </div>
          <Field name="url" 
                 component={renderTextAreaField}
                 rows={5}
                 label={__('Custom download URL slug (no space)')}
                 className="pda-textarea-field"
                 validate={[required]}
          />
          <Field name="limit_downloads" type="number"
                 component={renderField}
                 label={__('Download limit (leave blank for unlimited re-downloads)')}
                 className="pda-input-field"/>
          <Field name="expired_days" type="number" component={renderField}
                 label={__('Download expiry (enter the number of days before this download link expires, or leave blank for no expiry)')}
                 className="pda-input-field"/>
          <div className="pup-actions">
            <button className="btn button action" type="submit"
                    disabled={isPlanLite || pristine || submitting ||
                    this.wpData.isLicenseExpired}>{__('Submit')}
            </button>
          </div>
        </form>
      </div>
    );

    return this.state.loadingData ? this.renderLoading() : form;
  }

  renderLoading () {
    return (
      <div className="loading">{__('Loading Data...')}</div>
    );
  }

  onSubmit (values) {
    const { postId, bulkAddCustomUrl } = this.props;
    this.showLoading();
    values.urls = massageUrl(values.url);
    bulkAddCustomUrl(postId, values).then(() => {
      const { customUrlResponse, handleChangeTab } = this.props;
      this.hideLoading();
      if (customUrlResponse.isError) {
        toastr.error(
          __('Opps! Unable to create new custom private link due to duplicate slug.')
        );
      } else {
        toastr.success(MESSAGES.CREATE_NEW_PRIVATE_LINK);
        changeTab(TABS.TABLE);
        handleChangeTab(TABS.TABLE);
      }
    }).catch(() => {
      const { customUrlResponse } = this.props;
      this.hideLoading();
      if (customUrlResponse.isError) {
        toastr.error(
          __('Opps! Unable to create new custom private link due to duplicate slug.')
        );
      }
    });
  }
}

PuPForm.propTypes = {
  postId: PropTypes.string.isRequired,
  plan: PropTypes.object,
};

const Form = reduxForm({
  form: 'PupForm',  // a unique identifier for this form
  validate,
})(PuPForm);

const mapActionsToProps = (dispatch) => {
  return bindActionCreators({ bulkAddCustomUrl, changeTab, getPlan }, dispatch);
};

const mapStateToProps = (state) => {
  return {
    customUrlResponse: state.customUrl,
    initialValues: {
      is_prevented: true,
    },
    plan: state.getPlan,
  };
};

export default connect(mapStateToProps, mapActionsToProps)(Form);
